import React from 'react';
import { Accordion, Button, Card } from 'react-bootstrap';
import BzmIcon from 'components/icons/BzmIcon';

interface AccordionItemProps {
  isActive: boolean;
  onClick: (key: string) => void;
  title: string;
  eventKey: string;
  children: any;
}

const AccordionItem = (props: AccordionItemProps) => {
  const { isActive, eventKey, onClick, title } = props;
  const chevron = isActive ? 'down' : 'right';
  return (
    <Card className={isActive ? 'active' : undefined}>
      <Accordion.Toggle as={Card.Header} className={'p-2'} eventKey={title} onClick={e => onClick(eventKey)}>
        <Button variant={'link'} className={'btn btn-no-hover'}>
          <BzmIcon variant={'icon-bzm-chevron-' + chevron} className={'icon-sm'} />
        </Button>
        {title}
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={eventKey}>{props.children}</Accordion.Collapse>
    </Card>
  );
};

export default AccordionItem;
